import * as moment from 'moment';

export function formatDate(date: Date | number, format: string) {
    return moment(date).format(format);
}

export function combineCamelCase(...strings) {
    return strings.reduce((comb, str) => {
        if (!comb) {
            return str;
        }

        const upper = str[0].toUpperCase() + str.substr(1);
        return comb + upper;
    }, '');
}

export function getDisplayValue(name: string, settings: any) {
    const displayProperty = combineCamelCase('display', name);

    return settings[displayProperty];
}

export default {
    formatDate,
    combineCamelCase,
    getDisplayValue,
};


// WEBPACK FOOTER //
// ./src/components/widget/util/StringUtil.ts